/* The bundle grid's card, and the colour vocabulary the grid runs on.

   sf-claude.js draws a default card and looks for window.SFBundleCard
   first. This is that hook. It exists as its own file because the card is
   the part of the builder that gets redesigned, and the alternative was
   rewriting forty kilobytes of unrelated code every time a dot moved.

   THE DOT IS NOT ALWAYS THE FRAME'S COLOUR. Due | Large is eight silver
   frames with eight different lenses; Biker is named by its lens too —
   "Rose" is a blue frame with pink lenses. Colouring those by the frame
   gave a row of identical circles: accurate, useless, and the thing that
   made the family unreadable on the grid.

   The families grid solved this long ago and the answer is already in the
   data. A family carries custom.swatch_source, 'frame' or 'lens', and a
   custom.colour_map listing every product as "Frame|Lens" by product id.
   sf-card.liquid reads both, and sf-data now carries both.

   THE FOLDING IS COPIED FROM sf-colourlookup ON PURPOSE. That snippet
   folds every colour onto the twelve frame and nine lens colours the
   filters use — Rose and Maroon to Red, Gun to Grey, G15 to Green — and
   the palette in sf-swatch then gives one hex per name. Doing anything
   cleverer here would mean the same frame showing one colour on the
   families grid and another in the builder, which is worse than either
   choice on its own. If a colour looks wrong, it is wrong in both places
   and the fix belongs in the family's colour_map.

   THE FOLDING IS EXPORTED, as window.SFColour, because sf-bundlefilters
   needs exactly the same answers: a dot painted Red and a Red filter that
   does not match it would be a worse bug than either alone. One
   implementation, two callers, no list to keep in step.

   AN EXPLICIT SWATCH WINS OVER ALL OF IT. custom.swatch_hex on a product
   is the merchant saying "this one, precisely", and is used untouched.

   NO COLOUR MAP, NO PROBLEM. A family without one falls back to the words
   in the product's own name — "Silver Grey" reads as frame Silver, lens
   Grey — and failing that to the tint the builder used before. */
(function(){
"use strict";

/* One hex per colour name. Copied from sf-swatch.liquid; keep the two in
   step, or a dot changes colour when you walk between the two grids. */
var PAL={
  black:'#1a1a1a',grey:'#8b8f90',gray:'#8b8f90',gun:'#5a5f63',smoke:'#6e7376',
  silver:'#c9ced1',white:'#ffffff',clear:'#e8ecee',transparent:'#e8ecee',crystal:'#e8ecee',
  gold:'#c9a227',golden:'#c9a227',aurum:'#c9a227',electrum:'#b0b7bb',
  brown:'#6b4423',tortoise:'#8a5a2b',hazel:'#a9762f',beige:'#d9c3a5',biege:'#d9c3a5',
  nude:'#dcc0a8',camel:'#c19a6b',peach:'#f4c39c',rose:'#e2a0a0',pink:'#efa8c4',
  red:'#c0392b',maroon:'#6d1f2b',burgundy:'#6d1f2b',orange:'#e07a2f',yellow:'#f2d024',
  green:'#3f7d4f',olive:'#6f7d3f',teal:'#9bd1cc',tiffany:'#86d9d0',aqua:'#7ec8e3',
  blue:'#2f6fb0',navy:'#1f3864',purple:'#6b4c9a',violet:'#6b4c9a',rainbow:'#b8a3d9',
  tiger:'#b5651d',g15:'#3d4a3f',stone:'#a8a49c',carbon:'#2b2f31'
};

var FRAMES=['Black','Brown','Tortoise','Blue','Green','Grey','Silver','Gold','Red','Pink','Yellow','Clear'];
var LENSES=['Black','Brown','Green','Blue','Grey','Yellow','Pink','Red','Clear'];
var FOLD={Orange:'Yellow',Purple:'Blue',White:'Clear',Beige:'Clear',Gun:'Grey',
  Gunmetal:'Grey',Navy:'Blue',G15:'Green',Rose:'Red',Peach:'Pink',Maroon:'Red',
  Nude:'Clear',Tiffany:'Blue',Teal:'Blue',Olive:'Green',Bronze:'Brown',
  Champagne:'Yellow',Amber:'Yellow',Lilac:'Blue',Violet:'Blue',Ivory:'Clear',
  Cream:'Clear',Sand:'Clear',Crystal:'Clear',Transparent:'Clear'};

function cap(s){
  s=String(s||'').trim();
  return s ? s.charAt(0).toUpperCase()+s.slice(1).toLowerCase() : '';
}
function foldFrame(w){
  w=cap(w);
  if(FRAMES.indexOf(w)>-1) return w;
  w=FOLD[w]||w;
  return FRAMES.indexOf(w)>-1 ? w : '';
}
function foldLens(w){
  w=cap(w);
  if(w==='Gold') w='Yellow';
  else if(w==='Silver') w='Grey';
  else if(w==='Tortoise') w='Brown';
  if(LENSES.indexOf(w)>-1) return w;
  w=FOLD[w]||w;
  return LENSES.indexOf(w)>-1 ? w : '';
}

/* The shared vocabulary. sf-bundlefilters builds its facet index with
   these, so a dot and the filter button that should match it can never
   disagree. */
window.SFColour={
  frame: foldFrame,
  lens: foldLens,
  hex: function(w){ return PAL[String(w||'').toLowerCase()] || '' }
};

/* handle -> { swsrc, map: { pid: [frameWords, lensWord] } } */
var FAM=null;
function fams(){
  if(FAM) return FAM;
  FAM={};
  var d={};
  try{ d=JSON.parse((document.getElementById('sf-data')||{}).textContent||'{}') }catch(e){}
  (d.families||[]).forEach(function(f){
    var map={};
    String(f.cmap||'').split(';').forEach(function(e){
      var kv=e.split('='); if(kv.length<2) return;
      var parts=String(kv[1]).split('|');
      map[String(kv[0]).trim()]=[ (parts[0]||'').trim(), (parts[1]||'').trim() ];
    });
    FAM[f.handle]={ swsrc: f.swsrc==='lens' ? 'lens' : 'frame', map: map };
  });
  return FAM;
}

/* The colour word this dot should show, resolved the way sf-card does. */
function dotWord(p, fam){
  var e = fam && fam.map[String(p.pid)];
  var fw='', lw='';
  if(e){ fw=e[0]; lw=e[1] }
  else {
    /* "Due | Silver Grey" -> frame Silver, lens Grey. */
    var name=String(p.title||'').split('|').pop().trim().split(/\s+/);
    fw=name[0]||'';
    lw=name.length>1 ? name[name.length-1] : (name[0]||'');
  }
  if(fam && fam.swsrc==='lens'){
    var l=foldLens(lw);
    if(l) return l;
  }
  return foldFrame(String(fw).split('+')[0]) || foldLens(lw) || '';
}

function dotHex(p, fam, ctx){
  if(p.hex) return p.hex;                      /* the merchant said so */
  var w=dotWord(p, fam);
  if(w && PAL[w.toLowerCase()]) return PAL[w.toLowerCase()];
  return ctx.hex(p);                           /* the builder's old tint */
}

function esc(s){ return String(s||'').split('"').join('') }

window.SFBundleCard = function(g, ctx){
  var fam=fams()[g.key] || null;
  var sel=ctx.sel, on=ctx.picked(sel.id);
  var alt=esc(sel.title);

  var dots=g.items.map(function(p){
    var w=dotWord(p, fam);
    var label=esc(p.title)+(w?' \u2014 '+w+(fam&&fam.swsrc==='lens'?' lens':''):'');
    return '<i style="background:'+dotHex(p,fam,ctx)+'" title="'+label+'"'+
      ' data-vid="'+p.id+'"'+
      ' data-picked="'+(ctx.picked(p.id)?1:0)+'"'+
      ' aria-pressed="'+(p.id===sel.id)+'"'+
      ' onclick="SF.bundleSwatch(this,event)"></i>';
  }).join('');

  var n=g.items.length;
  return '<article class="card pickable famcard" data-fam="'+g.key+'" data-vid="'+sel.id+
    '" data-picked="'+(on?1:0)+'">'+
    '<div class="sh bshell" style="background:var(--tile)">'+
      '<span class="pk">'+ctx.tick+'</span>'+
      '<div class="bstrip" onclick="SF.togglePick('+sel.id+')">'+
        (sel.img?'<img src="'+sel.img+'" alt="'+alt+'" loading="lazy">':'')+
      '</div>'+
      '<button class="qa" onclick="SF.bundleDetails(\''+g.key+'\',event)">Choose colour</button>'+
    '</div>'+
    '<div class="meta"><span class="nm">'+g.title+'</span>'+
    '<span class="pr mono">'+ctx.money(sel.price)+
    ' <span class="cnt">&middot; '+ctx.colourName(sel.title)+
    (n>1?' &middot; '+n+' colours':'')+'</span></span></div>'+
    '<div class="dd">'+dots+'</div></article>';
};

/* sf-claude.js boots as soon as it runs, which on a deferred script is
   before this file has executed. One repaint puts the right dots in. */
if(document.getElementById('bGrid') && window.SF && typeof SF.renderBundles==='function'){
  SF.renderBundles();
}
})();